// extracted by mini-css-extract-plugin
export default {"linkbox":"link-box_linkbox__HOnL8","linkbox__link":"link-box_linkbox__link__cdNBP"};